<template>
  <div class="senansbtn_wrapper">
    <b-button @click="appendAnswer()">정답추가(+)</b-button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as R from "ramda";

const senStore = "senStore";
export default {
  computed: {
    ...mapState(senStore, ["flag", "ays_answers", "comt_answers"]),
  },
  methods: {
    ...mapActions(senStore, ["AC_AYS_ANSWER_APPEND", "AC_COMT_ANSWER_APPEND"]),
    appendAnswer() {
      let obj = { id: "0", text: "", strt: "S", intent: "" };

      if (this.flag == "1") {
        obj.id = this.ays_answers.length + 1;
        //apply same intent value with first one
        if (this.ays_answers.length > 0) {
          obj.intent = this.ays_answers[0].intent;
        }

        this.AC_AYS_ANSWER_APPEND(obj);
      } else if (this.flag == "2") {
        obj.id = this.comt_answers.length + 1;
        //apply same intent value with first one
        if (this.comt_answers.length > 0) {
          obj.intent = this.comt_answers[0].intent;
        }

        this.AC_COMT_ANSWER_APPEND(obj);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.senansbtn_wrapper {
  button {
    width: 100%;
  }
}
</style>